import { IListItem } from "../../classes/list-item";
import { IAppAction } from "../../classes/action";
import { ActionType } from "../actions/actiontype";
import { Action } from "redux";
import { FilterType } from "../../classes/filter-type";

export interface IListingState {
    list: IListItem[];
    relativeUrl: string;
    cache: { [cacheKey: string]: { lists: IListItem[], total: number, numberOfPage: number, filter: any } };
    currentlyRequesting: string;
    error: any;
    currPage: number;
    resultsPerPage: number;
    numberOfPages: number;
    totalResult: number;
    hideProviderImages: boolean;
    printResultText: string;
    pdfGenerationMessage: string;
    customDistanceErrorMessage: string;
    showDistanceFilter: boolean;
    enableAdvanceLocationLookup: boolean;
}

export const defaultListingState: IListingState = {
    list: [],
    relativeUrl: null,
    cache: {},
    error: null,
    currentlyRequesting: null,
    currPage: 1,
    resultsPerPage: 10,
    numberOfPages: 0,
    totalResult: 0,
    hideProviderImages: false,
    pdfGenerationMessage: null,
    printResultText: '',
    customDistanceErrorMessage: '',
    showDistanceFilter: false,
    enableAdvanceLocationLookup: false
};

export function listingReducer(state = defaultListingState, action: IAppAction): IListingState {
    switch (action.type) {
        case ActionType.REQUEST_LIST: {
            const cacheKey: string = action.value;

            return { ...state, currentlyRequesting: cacheKey };
        }

        case ActionType.STORE_LIST: {
            const cacheKey = action.value.cacheKey as string;
            const numberPages = action.value.numberPages as number;
            const total = action.value.totalResult as number;
            const printResultText = action.value.printResultText as string;
            // If the cache key exists in the state, update state with the cached list.
            if (cacheKey in state.cache) {
                return { ...state, list: state.cache[cacheKey].lists, totalResult: state.cache[cacheKey].total, numberOfPages: state.cache[cacheKey].numberOfPage };
            }

            const list = action.value.list as IListItem[];

            const insertToCache = { ...state.cache, [cacheKey]: { lists: list, total: total, numberOfPage: numberPages, filter: action.value.filter } };

            return { ...state, list: list, cache: insertToCache, numberOfPages: numberPages, currentlyRequesting: null, totalResult: total, printResultText: printResultText };
        }

        case ActionType.STORE_BASE_URL: {
            var randomInteger = Math.floor(Math.random() * Math.pow(2, 32));
            var withRandom = action.value + "randomSeed=" + randomInteger.toString() + "&";

            return { ...state, relativeUrl: withRandom, currentlyRequesting: null };
        }

        case ActionType.ERROR_LIST: {
            return { ...state, error: action.value };
        }

        case ActionType.GO_TO_PAGE: {
            return { ...state, currPage: action.value };
        }

        case ActionType.UPSERT_FILTER: {
            const filterProperty: string = action.value.property;
            const filterValue: string = action.value.value;

            if (filterProperty === FilterType.RESULTS_PER_PAGE) {
                return { ...state, resultsPerPage: parseInt(filterValue) };
            }

            return { ...state };
        }

        case ActionType.SET_PROVIDER_IMAGES: {
            return { ...state, hideProviderImages: action.value };
        }

        case ActionType.SET_PDF_GENERATION_MESSAGE: {
            return { ...state, pdfGenerationMessage: action.value }
        }

        case ActionType.SET_CUSTOM_DISTANCE_ERROR_MESSAGE: {
            return { ...state, customDistanceErrorMessage: action.value }
        }

        case ActionType.SET_SHOW_DISTANCE_FILTER: {
            return { ...state, showDistanceFilter: action.value }
        }

        case ActionType.SET_ENABLE_ADVANCE_LOCATION_LOOKUP: {
            return { ...state, enableAdvanceLocationLookup: action.value }
        }

        default: {
            return state;
        }
    }
}